const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

export function validateEmail(inputEmail:string) {
    return regex.test(inputEmail);
}
